import { render, staticRenderFns } from "./CompanyInfoForm.vue?vue&type=template&id=78894346&"
import script from "./CompanyInfoForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CompanyInfoForm.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports